// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f04f084f","769":"8d72c195"}[chunkId] + ".chunk.js";
};